import React, { useRef } from 'react';
import { useIntersection } from '../hooks/useScrolled';
import about from '../images/about.jpeg';
import './GoldenHistory.css';

export default function GoldenHistory() {
  const ref = useRef(null);
  const visible = useIntersection(ref);

  return (
    <section className="golden-history" id="about" ref={ref}>
      <div className={`golden-history__inner${visible ? ' visible' : ''}`}>
        {/* Left: Image collage - two women wearing gold jewellery */}
        <div className="golden-history__images">
          <div className="gh-img-wrap gh-img-wrap--main">
            <img
              src={about}
              alt="Woman in saree wearing gold jewellery"
              className="gh-img"
            />
          </div>
          {/* <div className="gh-img-wrap gh-img-wrap--secondary">
            <img
              src="https://images.unsplash.com/photo-1617038260897-41a1f14a8ca0?w=500&q=85"
              alt="Close up gold earrings and necklace"
              className="gh-img"
            />
          </div> */}
          {/* Gold decorative overlay */}
          <div className="gh-img-accent" />
        </div>

        {/* Right: Text content on white background */}
        <div className="golden-history__content">
          <h2 className="golden-history__title">Golden History</h2>
          <div className="gold-divider" />
          <p className="golden-history__body">
            JKS Jewels improved its product quality and services by adopting the ISO 9001:2008 quality management 
            system in 2008 for the manufacturing and wholesale of gold ornaments. 
            It became the first jewellery company in Karnataka to receive this certification.
          </p>
          <p className="golden-history__body" style={{ marginTop: '16px' }}>
            In an industry mostly run by traditional businesses, Mr. Prasad stands out as a self-made entrepreneur who has created job opportunities for hundreds of families through his company.
      </p>
      <p className="golden-history__body" style={{ marginTop: '5px' }}>
  In 2013, the company purchased its own multi-story building in Bangalore. Later, in 2016, it set up a large jewellery manufacturing unit spread across 18,000 square feet, with more than 100 skilled workers specializing in Antique and Temple jewellery. Apart from business, JKS Jewels also actively contributes to society by supporting social events, relief camps, and sports activities in Bangalore.
</p>
          <a href="#about" className="golden-history__cta">
            Discover More
          </a>
        </div>
      </div>
    </section>
  );
}
